import { useApiClient } from './apiClient';
import { useCallback, useMemo } from 'react';

export const useInventoryAPIs = () => {
  const { get, customDelete: del, post, putR } = useApiClient(); // Avoid conflict with JS reserved word 'delete'

  const fetchInventory = useCallback(async () => {
    
    try {
      const data = await get('assets');
      return data;
    } catch (err) {
      console.error("Failed to fetch inventory:", err);
      throw err;
    }
  }, [get]);

  const deleteAsset = useCallback(async (assetId) => {
    try {
      return await del(`assets/${assetId}`);
    } catch (err) {
      console.error("Failed to delete asset:", err);
      return false;
    }
  }, [del]);

  const addAsset = useCallback(async (asset) => {
    try {
      return await post('assets', asset);
    } catch (err) {
      console.error("Failed to add asset:", err);
      return false;
    }
  }, [post]);

  const updateAsset = useCallback(async (asset, assetId) => {
    try {
      return await putR(`assets/${assetId}`, asset);
    } catch (err) {
      console.error("Failed to update asset:", err);
      return false;
    }
  }, [putR]);

  const fetchAvailableAssets = useCallback(async (date, time) => {
    try {
      const data = await get(`assets/available?date=${date}&time=${time}`);
      return data;
    } catch (err) {
      console.error("Failed to fetch available assets:", err);
      throw err;
    }
  }, [get]);

  return useMemo(() => ({
    fetchInventory,
    deleteAsset,
    addAsset,
    updateAsset,
    fetchAvailableAssets,
  }), [fetchInventory, deleteAsset, addAsset, updateAsset, fetchAvailableAssets]);
};
